export default __webpack_public_path__ + "static/twitter-dark-063aa6c6a27e35ba7e4c85d3172b7878.png";